import request from "../../request.js";
import qs from "qs";

// 上次文件
export function uploadFileToYdy(data) {
  return request({
    url: "/ydy-file/uploadFileToYdy",
    method: "POST",
    data,
  });
}
// 上传文件到腾讯云-后端
export function uploadFileToTxCloudEquityFee(data) {
  return request({
    url: "/tx-cloud-file/uploadFileToTxCloudEquityShanxi",
    method: "POST",
    data,
  });
}
// 新增用户
export function addAjefUser(data) {
  return request({
    url: "/ajef-user/addAjefUser",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取腾讯云秘钥
export function getPolicyTxCloudEquityFee(data) {
  return request({
    url: "/tx-cloud-file/getPolicyTxCloudEquityShanxi",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取用户列表
export function getAjSalaryUserList(data) {
  return request({
    url: "/aj-salary-user/getAjSalaryUserList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑用户
export function updateAjefUser(data) {
  return request({
    url: "/ajef-user/updateAjefUser",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 登录
export function doLoginAjSalaryUser(data) {
  return request({
    url: "/aj-salary-user/doLoginAjSalaryUser",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除用户
export function deleteAjSalaryUser(data) {
  return request({
    url: "/aj-salary-user/deleteAjSalaryUser",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取工资条员工列表
export function getAjSalaryEmployeeList(data) {
  return request({
    url: "/aj-salary-employee/getAjSalaryEmployeeList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 批量导入工资条员工列表
export function uploadAjSalaryEmployee(data) {
  return request({
    url: "/aj-salary-employee/uploadAjSalaryEmployee",
    method: "POST",
    data,
  });
}
//编辑自己的密码
export function updateAjSalaryUserPw(data) {
  return request({
    url: "/aj-salary-user/updateAjSalaryUserPw",
    method: "POST",
    data: qs.stringify(data),
  });
}
//员工薪资表-重新发送
export function updateAjSalaryEmployeeMultiSend(data) {
  return request({
    url: "/aj-salary-employee/updateAjSalaryEmployeeMultiSend",
    method: "POST",
    data: qs.stringify(data),
  });
}
//员工薪资表-批量生成
export function updateAjSalaryEmployeeMultiCreate(data) {
  return request({
    url: "/aj-salary-employee/updateAjSalaryEmployeeMultiCreate",
    method: "POST",
    data: qs.stringify(data),
  });
}
//钉钉信息记录
export function getAjSalaryDingtalkMessageList(data) {
  return request({
    url: "/aj-salary-dingtalk-message/getAjSalaryDingtalkMessageList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//钉钉信息记录-处理
export function updateAjSalaryDingtalkMessageHandler(data) {
  return request({
    url: "/aj-salary-dingtalk-message/updateAjSalaryDingtalkMessageHandler",
    method: "POST",
    data: qs.stringify(data),
  });
}
//员工薪资模板表2-列表
export function getAjSalaryEmployeeTwoList(data) {
  return request({
    url: "/aj-salary-employee-two/getAjSalaryEmployeeTwoList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//员工薪资模板表2-批量生成
export function updateAjSalaryEmployeeTwoMultiCreate(data) {
  return request({
    url: "/aj-salary-employee-two/updateAjSalaryEmployeeTwoMultiCreate",
    method: "POST",
    data: qs.stringify(data),
  });
}
//员工薪资模板表2-批量发送
export function updateAjSalaryEmployeeTwoMultiSend(data) {
  return request({
    url: "/aj-salary-employee-two/updateAjSalaryEmployeeTwoMultiSend",
    method: "POST",
    data: qs.stringify(data),
  });
}
//员工薪资模板表2-批量导入员工薪资表
export function uploadAjSalaryEmployeeTwo(data) {
  return request({
    url: "/aj-salary-employee-two/uploadAjSalaryEmployeeTwo",
    method: "POST",
    data
  });
}
//员工薪资模板表3-列表
export function getAjSalaryEmployeeThreeList(data) {
  return request({
    url: "/aj-salary-employee-three/getAjSalaryEmployeeThreeList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//员工薪资模板表3-批量生成
export function updateAjSalaryEmployeeThreeMultiCreate(data) {
  return request({
    url: "/aj-salary-employee-three/updateAjSalaryEmployeeThreeMultiCreate",
    method: "POST",
    data: qs.stringify(data),
  });
}
//员工薪资模板表3-批量发送
export function updateAjSalaryEmployeeThreeMultiSend(data) {
  return request({
    url: "/aj-salary-employee-three/updateAjSalaryEmployeeThreeMultiSend",
    method: "POST",
    data: qs.stringify(data),
  });
}
//员工薪资模板表3-批量导入员工薪资表
export function uploadAjSalaryEmployeeThree(data) {
  return request({
    url: "/aj-salary-employee-three/uploadAjSalaryEmployeeThree",
    method: "POST",
    data
  });
}
//员工薪资模板表4-列表
export function getAjSalaryEmployeeFourList(data) {
  return request({
    url: "/aj-salary-employee-four/getAjSalaryEmployeeFourList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//员工薪资模板表4-批量生成
export function updateAjSalaryEmployeeFourMultiCreate(data) {
  return request({
    url: "/aj-salary-employee-four/updateAjSalaryEmployeeFourMultiCreate",
    method: "POST",
    data: qs.stringify(data),
  });
}
//员工薪资模板表4-批量发送
export function updateAjSalaryEmployeeFourMultiSend(data) {
  return request({
    url: "/aj-salary-employee-four/updateAjSalaryEmployeeFourMultiSend",
    method: "POST",
    data: qs.stringify(data),
  });
}
//员工薪资模板表4-批量导入员工薪资表
export function uploadAjSalaryEmployeeFour(data) {
  return request({
    url: "/aj-salary-employee-four/uploadAjSalaryEmployeeFour",
    method: "POST",
    data
  });
}
